import apiClient from "./config";

const serviceService = {
  // Get all services
  getAllServices: async () => {
    try {
      const response = await apiClient.get("/services");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get service by ID
  getServiceById: async (serviceId) => {
    try {
      const response = await apiClient.get(`/services/${serviceId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new service
  createService: async (serviceData) => {
    try {
      const response = await apiClient.post("/services", serviceData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update service
  updateService: async (serviceId, serviceData) => {
    try {
      const response = await apiClient.put(
        `/services/${serviceId}`,
        serviceData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete service
  deleteService: async (serviceId) => {
    try {
      const response = await apiClient.delete(`/services/${serviceId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default serviceService;
